import {
  SEARCH_GET_ENTITY_OBJECT_REQUEST,
  SEARCH_GET_ENTITY_OBJECT_SUCCESS,
  SEARCH_GET_ENTITY_OBJECT_ERROR,
  SEARCH_RECEIVE_CITY_REQUEST,
  SEARCH_RECEIVE_CITY_SUCCESS,
  SEARCH_RECEIVE_CITY_ERROR,
  SEARCH_GET_ENTITY_REQUEST,
  SEARCH_GET_ENTITY_SUCCESS,
  SEARCH_GET_ENTITY_ERROR,
  SEARCH_GET_OBJECT_REQUEST,
  SEARCH_GET_OBJECT_SUCCESS,
  SEARCH_GET_OBJECT_ERROR,
  SEARCH_RECEIVE_COMPANY_REQUEST,
  SEARCH_RECEIVE_COMPANY_SUCCESS,
  SEARCH_RECEIVE_COMPANY_ERROR,
  SEARCH_RECEIVE_PURPOSE_REQUEST,
  SEARCH_RECEIVE_PURPOSE_SUCCESS,
  SEARCH_RECEIVE_PURPOSE_ERROR,
  SEARCH_PURPOSE_CLEAR,
} from "../../../common/constants/action-constants";
import { RequestData } from '../../../common/components/city-autocomplete/CityAutocomplete';
import { PurposeOption } from '../../../common/components/purpose-autucomplete/usePurposes';

export const findEntityAndObjectByFiltersRequest = (requestData: any) => {
  return {
    type: SEARCH_GET_ENTITY_OBJECT_REQUEST,
    requestData,
  };
};

export const findEntityAndObjectByFiltersSuccess = (result: any) => {
  return {
    type: SEARCH_GET_ENTITY_OBJECT_SUCCESS,
    result,
  };
};

export const findEntityAndObjectByFiltersError = (error: any) => {
  return {
    type: SEARCH_GET_ENTITY_OBJECT_ERROR,
    error,
  };
};

export const receiveCityRequest = (requestData: RequestData) => {
  return {
    type: SEARCH_RECEIVE_CITY_REQUEST,
    requestData,
  };
};

export const receiveCitySuccess = (result: any) => {
  return {
    type: SEARCH_RECEIVE_CITY_SUCCESS,
    result,
  };
};

export const receiveCityError = (error: any) => {
  return {
    type: SEARCH_RECEIVE_CITY_ERROR,
    error,
  };
};

export const receivePurposeRequest = (requestData: RequestData) => {
  return {
    type: SEARCH_RECEIVE_PURPOSE_REQUEST,
    requestData,
  };
};

export const receivePurposeSuccess = (items: PurposeOption[], query: string) => {
  return {
    type: SEARCH_RECEIVE_PURPOSE_SUCCESS,
    items,
    query,
  };
};

export const receivePurposeError = (error) => {
  return {
    type: SEARCH_RECEIVE_PURPOSE_ERROR,
    error,
  }
};

export const clearPurpose = () => {
  return {
    type: SEARCH_PURPOSE_CLEAR,
  }
}

export const findEntityByFiltersRequest = (requestData: any) => {
  return {
    type: SEARCH_GET_ENTITY_REQUEST,
    requestData,
  };
};

export const findEntityByFilterSuccess = (result: any) => {
  return {
    type: SEARCH_GET_ENTITY_SUCCESS,
    result,
  };
};

export const findEntityByFiltersError = (error: any) => {
  return {
    type: SEARCH_GET_ENTITY_ERROR,
    error,
  };
};

export const findObjectByFiltersRequest = (requestData: any) => {
  return {
    type: SEARCH_GET_OBJECT_REQUEST,
    requestData,
  };
};

export const findObjectByFilterSuccess = (result: any) => {
  return {
    type: SEARCH_GET_OBJECT_SUCCESS,
    result,
  };
};

export const findObjectByFiltersError = (error: any) => {
  return {
    type: SEARCH_GET_OBJECT_ERROR,
    error,
  };
};

export const receiveCompanyRequest = (data: any) => {
  return {
    type: SEARCH_RECEIVE_COMPANY_REQUEST,
    data,
  };
};

export const receiveCompanySuccess = (companies: any) => {
  return {
    type: SEARCH_RECEIVE_COMPANY_SUCCESS,
    companies,
  };
};

export const receiveCompanyError = (error: any) => {
  return {
    type: SEARCH_RECEIVE_COMPANY_ERROR,
    error,
  };
};

export type PurposeActions =
  | ReturnType<typeof receivePurposeRequest> | ReturnType<typeof receivePurposeSuccess> | ReturnType<typeof receivePurposeError> | ReturnType<typeof clearPurpose>;


